import { receiveChatStream, type ChatStreamOptions } from "@/utils/chat_stream";
import type { DefaultApi } from "@/api";
import { PositionChats } from "@/models/position_chats";
import { PositionChat } from "@/models/position_chat";
import type { State as RootState } from "@/stores";
import type { Module } from "vuex";
export interface State {
  positionChats?: PositionChats;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    positionChats: undefined,
  },
  actions: {
    async getPositionChat({ commit }, positionId: number) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getPositionChat(positionId);
      const chats = new PositionChats(
        response.data.map(
          (chat: Partial<PositionChat>) => new PositionChat(chat),
        ),
      );
      commit("setPositionChats", chats);
      return chats;
    },
    async postPositionChat(
      { commit },
      {
        positionId,
        message,
        onText,
        onError,
        signal,
      }: {
        positionId: number;
        message: string;
      } & ChatStreamOptions,
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const data = await receiveChatStream<PositionChat[]>(
        (options) => api.postPositionChat(positionId, { message }, options),
        { onText, onError, signal },
      );
      const chats = new PositionChats(
        data.map((chat: Partial<PositionChat>) => new PositionChat(chat)),
      );
      commit("appendPositionChat", chats);
      return chats;
    },
  },
  mutations: {
    setPositionChats(state, chats: PositionChats) {
      state.positionChats = chats;
    },
    appendPositionChat(state, chats: PositionChats) {
      state.positionChats = new PositionChats([
        ...(state.positionChats ?? []),
        ...chats,
      ]);
    },
  },
};
